import { addBodyLock, removeBodyLock } from './lock-body';

export { addBodyLock, removeBodyLock };
